import { Typography, Box, Button } from "@mui/material";
import { NotEligibleForPaymentArrangements } from "../../../SharedComponents/contents";

interface quickBillPendingProps {
    onClose: () => void;
    handlePrimary: () => void;
}

function QBPBillPending({ onClose, handlePrimary }: quickBillPendingProps) {
  const notEligibleForPaymentArrangements : any = NotEligibleForPaymentArrangements();
  const JSONcontent : any = notEligibleForPaymentArrangements?.entry;
    const QBPpendingJSON = JSONcontent?.qbpPending;
    return (
        <Box className="nonAuthEligibleModalBox">
            <Typography className="billPreparedmodalTitle">{QBPpendingJSON?.billPrepared}</Typography>
            <Typography className="billPreparedModaldescription">{QBPpendingJSON?.checkBackLater}</Typography>

            <Box className="buttonBoxContainer">
              <Button
                variant="outlined"
                color="primary"
                onClick={onClose}
                className="secondary nonAuthEligibleBtn"
                sx={{ textTransform: "none" }}
              >
                {QBPpendingJSON?.closeBtn}
              </Button>
              <Button
                variant="contained"
                color="primary"
                className="primary nonAuthEligibleBtn"
                sx={{ textTransform: "none" }}
                onClick={handlePrimary}
              >
                {QBPpendingJSON?.signInButton}
              </Button>
            </Box>
        </Box>
    );
}

export default QBPBillPending;